<template>
  <b-card
    :title="translations.resetOtpAttempts[lang]"
    @cancel="handleCancel"
    @submit="submitReset"
    :disabled="!formValid"
    :submit-text="{ el: 'Επιβεβαίωση', en: 'Confirm', it: 'Conferma' }"
    :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
    :loading="loading"
  >
    <v-row no-gutters>
      <v-col cols="12" class="pr-2 d-flex">
        <v-select
          :items="activeCountries"
          label="CC*"
          outlined
          v-model="country_id"
          item-value="country_id"
          no-top-margin
          item-text="name"
          solo
          flat
          dense
          hide-details="auto"
          color="secondary"
          item-color="secondary"
          class="country-code-select"
          :rules="[(v) => !!v || translations.requiredField[lang]]"
        >
          <template v-slot:selection="{ item }">
            <v-row no-gutters class="d-flex align-center">
              <v-col class="mr-0">
                <img :src="item.flag" width="25" style="vertical-align: middle" class="mr-0" />
              </v-col>
              <v-col cols="auto">{{ item.phone_code }}</v-col>
            </v-row>
          </template>
          <template v-slot:item="{ item }">
            <v-row no-gutters>
              <v-col class="mr-3">
                <img :src="item.flag" width="25" style="vertical-align: middle" class="mr-3" />
                {{ item.name }} ({{ item.code }})
              </v-col>
              <v-col cols="auto">{{ item.phone_code }}</v-col>
            </v-row>
          </template>
        </v-select>
        <b-text-field
          v-model="mobile"
          v-mask="'############'"
          :label="translations.resetOtpMobile[lang]"
          no-top-margin
          :rules="mobileRules"
          class="user-mobile"
        ></b-text-field>
      </v-col>
    </v-row>
  </b-card>
</template>

<script>
import validators from '@/utils/validators/loyaltyPanel/customers';
import translations from '@/utils/translations/loyaltyPanel/customers';
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ResetOtpAttemptsDialog',
  mixins: [validators, translations],
  data: () => ({
    mobile: null,
    country_id: null,
  }),
  computed: {
    ...mapState(['loading', 'store']),
    ...mapGetters(['activeCountries']),
    lang() {
      return this.$route.params.lang;
    },
    formValid() {
      return this.mobile && this.country_id;
    },
    mobileRules() {
      return [(v) => this.validateMobile(v)];
    },
  },
  methods: {
    ...mapMutations(['setNotification']),
    ...mapActions(['loadActiveCountries']),
    ...mapActions('loyaltyPanel/customers', ['resetOtpAttempts']),
    async submitReset() {
      const result = await this.resetOtpAttempts({
        mobile: this.mobile,
        country_id: this.country_id,
      });
      if (result) {
        this.setNotification({
          show: true,
          type: 'success',
          text: this.translations.resetOtpAttemptsSuccess[this.lang],
        });
        this.resetData();
        this.$emit('reset-complete');
      }
    },
    validateMobile(mobile) {
      if (!mobile) {
        return this.translations.mobileRequiredError?.[this.lang] || 'Error';
      } else if (!/^\d+$/.test(mobile)) {
        return this.translations.mobileDigitsError?.[this.lang] || 'Error';
      } else if (mobile.length < 7 || mobile.length > 12) {
        return this.translations.mobileLengthError?.[this.lang] || 'Error';
      }
      return true;
    },
    handleCancel() {
      this.resetData();
      this.$emit('cancel');
    },
    resetData() {
      this.mobile = null;
      this.country_id = this.store?.country?.country_id ?? null;
    },
  },
  async mounted() {
    if (!this.activeCountries?.length) {
      await this.loadActiveCountries();
    }
    this.resetData();
  },
};
</script>

<style lang="scss">
.country-code-select .v-input__slot {
  min-width: 110px;
  padding: 0 4px 0 8px !important;
}
.country-code-select .v-select__selections input {
  padding: 0 !important;
  margin: 0 !important;
  height: 0 !important;
  width: 0 !important;
  overflow: hidden !important;
}

.country-code-select .v-input__append-inner {
  padding-left: 0 !important;
}

.country-code-select .v-input__append-inner .v-icon.v-icon::after {
  max-width: 20px;
  min-width: 20px;
}

.country-code-select fieldset {
  border-right: 1px dotted black !important;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.user-mobile fieldset {
  border-left: none !important;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
</style>
